const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'
const TELEMETRY_ENDPOINT = `${API_URL}/observability/frontend/event`

const createRequestId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `req-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

const toPath = () => {
  if (typeof window === 'undefined') {
    return ''
  }
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}

const sendFrontendEvent = ({ level = 'info', event = 'frontend_event', message = '', metadata = {}, requestId = '' }) => {
  const payload = {
    level,
    event,
    message,
    path: toPath(),
    requestId,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    metadata,
  }

  const body = JSON.stringify(payload)

  if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
    try {
      const blob = new Blob([body], { type: 'application/json' })
      navigator.sendBeacon(TELEMETRY_ENDPOINT, blob)
      return
    } catch (error) {
      // fallback para fetch abaixo
    }
  }

  if (typeof fetch === 'function') {
    fetch(TELEMETRY_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => undefined)
  }
}

export { createRequestId, sendFrontendEvent }
